import { connect } from 'react-redux';
import PaymentDetails from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetails);
